import { BaseComponent, IStateBase } from 'components/BaseComponent';
import Grid from '@material-ui/core/Grid';
import React from 'react';
import { paymentService } from 'services/PaymentService';
import { ICartModel } from 'interfaces/ICartModel';
import FieldText from 'components/Field/Text';
import Translate from 'components/Translate';
import { IProductData, enCurrency } from 'interfaces/IProductData';
import SuggestEmail from './SuggestEmail/index';
import { cartService } from 'services/CartService';
import { enProductType } from 'enums/enProductType';
import CpfForm from '../Payment/PaymentForm/CpfForm';
import { enPaymentType } from 'enums/enPaymentType';
import { currencyService } from 'services/CurrencyService';
import Tooltip from '@material-ui/core/Tooltip/Tooltip';
import Fade from '@material-ui/core/Fade';
import { Hidden } from '@material-ui/core';

interface IState extends IStateBase {
  model: ICartModel;
  currency: enCurrency;
  suggest: boolean;
  cart: IProductData;
  lock: boolean;
  personType: string;
}

export default class UserForm extends BaseComponent<IState> {
  constructor(props: any) {
    super(props);
    this.state = { suggest: false, currency: undefined, cart: undefined, personType: undefined, model: undefined, lock: false };
  }

  componentDidMount() {
    this.bindModel(paymentService.getCart());
    this.observeState({ currency: null }, currencyService.getCurrency());
    this.observeState({ cart: null }, cartService.getCart());

    paymentService.getCart().subscribe((cart) => this.setState({ personType: cart.personType }));

    cartService
      .getCart()
      .bindComponent(this)
      .filter((cart) => !!cart.user)
      .map((cart) => cart.user.lock)
      .subscribe((lock) => {
        this.setState({ lock });
      });
  }

  componentDidUpdate() {
    if (this.state.formSubmitted != this.props.formSubmitted) {
      this.setState({ formSubmitted: this.props.formSubmitted });
    }
  }

  autoSuggest = (email: any) => {
    this.setState({ suggest: email.includes('@') });
  };

  autoComplete = (value: any) => {
    const email = `${this.state.model.email.split('@')[0]}${value}`;

    paymentService.setData({ email });
    this.setState({ suggest: false });
  };

  disableSuggest = () => {
    setTimeout(() => this.setState({ suggest: false }), 300);
  };

  setEmail = (email: any) => {
    this.autoSuggest(email);
    paymentService.setData({ email });
  };

  setConfirmEmail = (confirmEmail: any) => {
    paymentService.setData({ confirmEmail });
  };

  setPhone = (phone: any) => {
    paymentService.setData({ phone });
  };

  setName = (name: any) => {
    paymentService.setData({ name });
  };

  switchPersonType = (e: any) => {
    e.preventDefault();
    paymentService.switchPersonType();

    paymentService.setInstallmentsByPersonType();
  };

  render() {
    if (!this.state.model) {
      return <div />;
    }

    const { model, cart, lock, personType } = this.state;

    const ead = cart.config.ead;
    const nameField = (
      <FieldText
        id="name"
        disabled={lock}
        label={<Translate term={ead ? 'Nome completo do responsável financeiro' : 'Nome Completo'} />}
        validation="required|name|max:100"
        value={model.name}
        mask="name"
        onChange={this.setName}
        inputProps={{
          className: `theme-input ${lock ? 'disabledField' : ''}`
        }}
        InputLabelProps={{
          className: 'theme-label',
          id: 'label-name'
        }}
      />
    );

    return (
      <div className="chk-user-form">
        <Grid container spacing={1}>
          <Grid item xs={12}>
            {cart.config.ead ? (
              <div className="tooltip-card">
                <Hidden xsDown>
                  <Tooltip
                    id="tooltip-financial-name"
                    placement="top"
                    classes={{
                      popper: 'card-popper',
                      tooltip: 'card-tooltip-text'
                    }}
                    disableTouchListener={true}
                    TransitionComponent={Fade}
                    TransitionProps={{ timeout: 600 }}
                    title={<Translate term="Este nome aparecerá na nota fiscal" />}
                  >
                    <div className="question-mark theme-button">?</div>
                  </Tooltip>
                </Hidden>
                {nameField}
              </div>
            ) : (
              nameField
            )}
          </Grid>

          <Grid item xs={12} sm={cart.config.productType == enProductType.TICKET ? 6 : 12}>
            <div className="tooltip-email-information">
              <FieldText
                id="email"
                disabled={lock}
                label={<Translate term={ead ? 'E-mail do responsável financeiro' : 'E-mail'} />}
                validation="required|email|max:150"
                value={model.email}
                type="email"
                mask="nospace"
                onChange={this.setEmail}
                onPaste={(e) => e.preventDefault()}
                onBlur={this.disableSuggest}
                inputProps={{
                  className: `theme-input ${lock ? 'disabledField' : ''}`
                }}
                InputLabelProps={{
                  className: 'theme-label',
                  id: 'label-email'
                }}
              />
              {this.state.suggest && <SuggestEmail email={model.email.split('@')[1]} autoComplete={this.autoComplete} />}
            </div>
          </Grid>

          {cart.config.askEmailConfirmation !== false && (
            <Grid item xs={12} sm={cart.config.productType == enProductType.TICKET ? 6 : 12}>
              <FieldText
                id="confirmation"
                autoComplete="off"
                disabled={lock}
                label={<Translate term={'Confirmar e-mail'} />}
                validation={`required|email|max:150|equal:${model.email}`}
                value={model.confirmEmail}
                type="email"
                mask="nospace"
                onChange={this.setConfirmEmail}
                onPaste={(e) => e.preventDefault()}
                inputProps={{
                  className: `theme-input ${lock ? 'disabledField' : ''}`
                }}
                InputLabelProps={{
                  className: 'theme-label',
                  id: 'label-email'
                }}
              />
            </Grid>
          )}

          <Grid item xs={12} sm={cart.config.productType == enProductType.TICKET ? 6 : 12}>
            <FieldText
              id="cellphone"
              disabled={lock}
              label={<Translate term="Celular" />}
              validation={personType != 'E' ? 'required|min:10' : 'required|min:3|max:36'}
              value={model.phone}
              mask={personType != 'E' ? 'phone' : null}
              type="tel"
              onChange={this.setPhone}
              inputProps={{
                className: `theme-input ${lock ? 'disabledField' : ''}`
              }}
              InputLabelProps={{
                className: 'theme-label',
                id: 'label-phone'
              }}
            />
          </Grid>
          {(cart.config.paymentType === enPaymentType.FREE || cart.config.ead) && (
            <Grid item xs={12}>
              <CpfForm />
            </Grid>
          )}
        </Grid>
      </div>
    );
  }
}
